import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const Search2 = (props) => (
  <Icon viewBox="0 0 19 20" {...props}>
    <g>
      <title>Group</title>
      <g fill="currentColor" fillRule="evenodd">
        <path d="M9 17.65A8.65 8.65 0 1 0 9 .35a8.65 8.65 0 0 0 0 17.3zm0-1.3a7.35 7.35 0 1 1 0-14.7 7.35 7.35 0 0 1 0 14.7z" />
        <path d="M14.04 15.96l3.536 3.535.46.46.919-.92-.46-.46-3.535-3.535-.46-.46-.92.92z" />
      </g>
    </g>
  </Icon>
);
/*eslint-enable */

export default Search2;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/Search2.js